"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingItem = PricingItem;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const ListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ListContainer",
  class: "pl-l1kzbt3y"
});
const Inner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Inner",
  class: "pl-i1cvgnba"
});
const ListWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ListWrapper",
  class: "pl-l18incfu"
});
const List = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "List",
  class: "pl-l1mofiou"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i9r56k7"
});

/**
 * Pricing Item component.
 *
 * @param {Object} props React props
 * @param {string} props.text List of Items Left
 * @param {string} props.icon List of Icons Left
 * @param {string} props.color List of Items Right
 * @returns {React.ReactElement} Pricing Item component
 * @public
 */
function PricingItem({
  text,
  icon
}) {
  return /*#__PURE__*/_react.default.createElement(ListContainer, {
    "data-cy": "pricing-item",
    className: "pricing-item"
  }, /*#__PURE__*/_react.default.createElement(Inner, null, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  })), /*#__PURE__*/_react.default.createElement(ListWrapper, null, /*#__PURE__*/_react.default.createElement(List, {
    "data-cy": "pricing-item-text"
  }, text))));
}
PricingItem.propTypes = {
  text: _propTypes.default.string,
  icon: _propTypes.default.string
};